import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiZap, FiShield, FiTrendingUp, FiInfo } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { pricingPlans } from '../../data/pricing';
import { Link } from 'react-router-dom';

const PricingTable = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-8 items-stretch">
          {pricingPlans.map((plan, i) => (
            <motion.div
              key={plan.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className={`relative flex flex-col p-8 rounded-[2.5rem] border ${
                plan.popular 
                  ? 'border-orange-500 shadow-2xl ring-4 ring-orange-500/10 z-10' 
                  : 'border-slate-200 bg-slate-50/50'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-orange-600 text-white px-6 py-1.5 rounded-full text-xs font-black uppercase tracking-widest shadow-lg">
                  Most Popular for Trades
                </div>
              )}

              <div className="mb-8">
                <h3 className="text-2xl font-black text-slate-900 mb-2">{plan.name}</h3>
                <p className="text-slate-500 text-sm leading-relaxed min-h-[48px]">
                  {plan.description}
                </p>
              </div>

              <div className="mb-8">
                <div className="flex items-baseline gap-1">
                  <span className="text-sm font-bold text-slate-400">$</span>
                  <span className="text-5xl font-black text-slate-900">{plan.price}</span>
                  <span className="text-slate-400 font-bold">/{plan.period}</span>
                </div>
                <div className="mt-4 inline-flex items-center gap-2 px-3 py-1 bg-slate-900 text-white rounded-lg text-[10px] font-black uppercase tracking-tighter">
                  <SafeIcon icon={FiZap} className="text-orange-500" /> {plan.aeoStatus}
                </div>
              </div>

              <div className="space-y-4 mb-10 flex-grow">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="mt-1 w-5 h-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center shrink-0">
                      <SafeIcon icon={FiCheck} className="text-xs" />
                    </div>
                    <span className="text-slate-700 text-sm font-medium leading-tight">{feature}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/audit"
                className={`w-full py-4 rounded-xl font-black text-center transition-all ${
                  plan.popular
                    ? 'bg-orange-600 text-white hover:bg-orange-700 shadow-lg shadow-orange-600/20'
                    : 'bg-slate-900 text-white hover:bg-slate-800'
                }`}
              >
                {plan.cta}
              </Link>

              <p className="mt-4 text-center text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                No long-term contracts. Cancel anytime.
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingTable;